/* Coral Keepsake story-book fitter (books whose name sits inside paragraphs, e.g. the Little Bible Storybook).
   Layout units are the 8×8 in PDF points; the 11×11 book is the same layout scaled up.
   Rules (verse books keep every line and only shrink the verse): keep the designer's line breaks while every line fits; if the name makes a line too wide,
   re-wrap that paragraph from the long line onward and move the rest of the page down;
   only if the page would run past its safe bottom, the name paragraph is set slightly smaller. */
(function(root){
'use strict';
function make(C){
  const adv=(t,s,f)=>C.metrics(t,s,f).advance;
  function wrap(words,size,font,maxW){
    const out=[];let line='';
    for(const w of words){
      if(adv(w,size,font)>maxW)return null;
      const cand=line?line+' '+w:w;
      if(line&&adv(cand,size,font)>maxW){out.push(line);line=w;}else line=cand;
    }
    if(line)out.push(line);
    return out;
  }
  function fitSingle(slot,text){
    const w=adv(text,slot.size,slot.font);let size=slot.size;
    if(w>slot.maxW)size=slot.size*slot.maxW/w;
    return {text,font:slot.font,size,x:slot.center,y:slot.y,color:slot.color,fits:Number.isFinite(size)&&size>=slot.minSize-1e-6,reduced:size<slot.size-1e-3};
  }
  function fitPage(page,name){
    const fill=t=>t.replaceAll('[Name]',name);
    const singles=page.single.map(s=>fitSingle(s,fill(s.text)));
    for(const scale of [1,0.97,0.94,0.91,0.88]){
      let shift=0,ok=true,reduced=false;const lines=[];
      for(const p of page.paras){
        const texts=p.lines.map(l=>fill(l.text)),has=p.lines.some(l=>l.text.includes('[Name]')),font=p.lines[0].font;
        if(p.verse){
          // Rhyming verse: line breaks never change. If a long name makes a line too wide,
          // the whole verse is set a little smaller so all its lines stay the same size.
          const widest=Math.max(...texts.map(t=>adv(t,p.size,font)));
          const k=Math.min(1,page.maxW/widest);
          if(!Number.isFinite(k)||k<(p.minScale||0.7)){ok=false;break;}
          if(k<1)reduced=true;
          texts.forEach((t,i)=>lines.push({text:t,font:p.lines[i].font,size:p.size*k,x:p.center,y:p.lines[i].y-shift,color:p.color}));
          continue;
        }
        const size=has?p.size*scale:p.size;
        let set=texts;
        const over=texts.findIndex(t=>adv(t,size,font)>page.maxW);
        if(has&&over>=0){
          const rest=wrap(texts.slice(over).join(' ').split(' ').filter(Boolean),size,font,page.maxW);
          if(!rest){ok=false;break;}
          set=texts.slice(0,over).concat(rest);
        }
        if(has&&size<p.size)reduced=true;
        const y0=p.lines[0].y-shift;
        set.forEach((t,i)=>{
          const src=p.lines[Math.min(i,p.lines.length-1)];
          lines.push({text:t,font:i<p.lines.length?src.font:font,size:(has?size:p.size),x:p.center,y:y0-i*p.lead,color:p.color});
        });
        shift+=(set.length-p.lines.length)*p.lead;
      }
      if(!ok)continue;
      const low=Math.min(...lines.map(l=>l.y));
      if(low>=page.floor-1e-6)return {page:page.page,lines:singles.concat(lines),fits:singles.every(s=>s.fits),reduced:reduced||singles.some(s=>s.reduced)};
    }
    return {page:page.page,lines:singles,fits:false,reduced:true};
  }
  /* Books with book.dedicationFit print a fixed lead-in (e.g. "With love from,") above the sign-off
     and may sit lower on the page, so they get their own safe bottom. Others use the shared engine. */
  function fitDedication(book,text,from){
    const D=book.dedicationFit;if(!D)return C.fitDedication(text,from);
    if(from&&D.fromLead)from=D.fromLead+String.fromCharCode(10)+from;
    const M=C.MASTER,bottom=D.bottom||M.dedication.message.bottom;
    // Optional per-book overrides so the page matches the designer's own spacing and line length.
    const msg={...M.dedication.message,...(D.messageWidth?{width:D.messageWidth}:{}),...(D.messageLineHeight?{lineHeightFactor:D.messageLineHeight}:{})};
    const sign={...M.dedication.from,...(D.fromLineHeight?{lineHeightFactor:D.fromLineHeight}:{})};
    for(let step=0;step<=20;step++){
      const size=msg.size-(msg.size-msg.minSize)*step/20,lineHeight=size*msg.lineHeightFactor;
      const lines=C.wrapText(text,msg,size);if(!lines)continue;
      const signSize=sign.size-(sign.size-sign.minSize)*step/20,signHeight=signSize*sign.lineHeightFactor;
      const signLines=from?C.wrapText(from,sign,signSize):[];if(!signLines)continue;
      const signY=sign.y+Math.max(0,lines.length-1)*lineHeight;
      const last=signLines.length?signY+(signLines.length-1)*signHeight+signSize:msg.y+(lines.length-1)*lineHeight+size;
      if(last<=bottom)return {fits:true,message:{...msg,size,lines,lineHeight,reduced:step>0},from:{...sign,size:signSize,lines:signLines,lineHeight:signHeight,y:signY,reduced:step>0},reduced:step>0};
    }
    return {fits:false,message:{...msg,lines:[]},from:{...sign,lines:[]},reduced:true};
  }
  /* fields = C.validateFields(...) result. Returns cover per size, dedication, and fitted pages. */
  function layout(book,fields){
    const errors={...fields.errors},name=fields.name||'Your child',M=C.MASTER;
    const pages=book.pages.filter(p=>p.page!==1).map(p=>fitPage(p,name));
    const covers={};
    for(const [k,c] of Object.entries(book.covers))covers[k]=fitSingle(c,c.text.replaceAll('[Name]',name));
    const dedicationName=C.fitText('For '+name,M.dedication.name);
    const dedicationLayout=fitDedication(book,fields.dedication||C.DEFAULT_DEDICATION,fields.from);
    if(fields.name&&!errors.name){
      const bad=pages.filter(p=>!p.fits).map(p=>p.page);
      if(bad.length||!dedicationName.fits||Object.values(covers).some(c=>!c.fits))
        errors.name='This name is too long to fit '+(bad.length?'book page '+bad.join(', '):'the cover')+' at a readable size. Please use a shorter preferred first name or contact us. Every letter is kept.';
    }
    if(!errors.dedication&&!errors.from&&!dedicationLayout.fits){errors.dedication='The dedication and sign-off won’t fit at a readable size. Please shorten the message or break up a very long word.';if(fields.from)errors.from='Please check the dedication and sign-off together.';}
    return {fields,errors,valid:Object.keys(errors).length===0,name,possessive:C.possessiveName(name),dedication:fields.dedication||C.DEFAULT_DEDICATION,from:fields.from,covers,pages,dedicationName,dedicationLayout,
      anyNameReduced:pages.some(p=>p.reduced)||Object.values(covers).some(c=>c.reduced)||dedicationName.reduced};
  }
  return {layout,fitPage,fitSingle,wrap};
}
root.CoralStoryFit={make};
if(typeof module==='object'&&module.exports)module.exports={make};
})(typeof window!=='undefined'?window:globalThis);
